/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CreateVehicleRequest
 */
export interface CreateVehicleRequest {
    /**
     *
     * @type {string}
     * @memberof CreateVehicleRequest
     */
    registrationPlate?: string;
    /**
     *
     * @type {string}
     * @memberof CreateVehicleRequest
     */
    jurisdiction?: CreateVehicleRequestJurisdictionEnum;
    /**
     *
     * @type {string}
     * @memberof CreateVehicleRequest
     */
    organisationId?: string;
    /**
     *
     * @type {string}
     * @memberof CreateVehicleRequest
     */
    friendlyName?: string;
    /**
     *
     * @type {string}
     * @memberof CreateVehicleRequest
     */
    make?: string;
    /**
     *
     * @type {string}
     * @memberof CreateVehicleRequest
     */
    model?: string;
    /**
     *
     * @type {number}
     * @memberof CreateVehicleRequest
     */
    year?: number;
    /**
     *
     * @type {string}
     * @memberof CreateVehicleRequest
     */
    colour?: string;
    /**
     *
     * @type {string}
     * @memberof CreateVehicleRequest
     */
    vehicleType?: CreateVehicleRequestVehicleTypeEnum;
    /**
     *
     * @type {string}
     * @memberof CreateVehicleRequest
     */
    vin?: string;
    /**
     *
     * @type {number}
     * @memberof CreateVehicleRequest
     */
    batteryCapacityKwh?: number;
    /**
     *
     * @type {string}
     * @memberof CreateVehicleRequest
     */
    macAddress?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof CreateVehicleRequest
     */
    connectorTypes?: Array<CreateVehicleRequestConnectorTypesEnum>;
    /**
     *
     * @type {string}
     * @memberof CreateVehicleRequest
     */
    notes?: string;
    /**
     *
     * @type {string}
     * @memberof CreateVehicleRequest
     */
    status?: CreateVehicleRequestStatusEnum;
}

/**
 * @export
 */
export const CreateVehicleRequestJurisdictionEnum = {
    Unknown: "Unknown",
    Act: "ACT",
    Nsw: "NSW",
    Nt: "NT",
    Qld: "QLD",
    Sa: "SA",
    Tas: "TAS",
    Vic: "VIC",
    Wa: "WA",
    National: "National",
} as const;
export type CreateVehicleRequestJurisdictionEnum =
    (typeof CreateVehicleRequestJurisdictionEnum)[keyof typeof CreateVehicleRequestJurisdictionEnum];

/**
 * @export
 */
export const CreateVehicleRequestVehicleTypeEnum = {
    Unknown: "Unknown",
    Bev: "BEV",
    Phev: "PHEV",
    Fcev: "FCEV",
} as const;
export type CreateVehicleRequestVehicleTypeEnum =
    (typeof CreateVehicleRequestVehicleTypeEnum)[keyof typeof CreateVehicleRequestVehicleTypeEnum];

/**
 * @export
 */
export const CreateVehicleRequestConnectorTypesEnum = {
    Unknown: "Unknown",
    ChAdeMo: "CHAdeMO",
    Ccs: "CCS",
    Ccs2: "CCS2",
    Type1: "Type1",
    Type2: "Type2",
    Mcs: "MCS",
    Pantograph: "Pantograph",
    Domestic: "Domestic",
} as const;
export type CreateVehicleRequestConnectorTypesEnum =
    (typeof CreateVehicleRequestConnectorTypesEnum)[keyof typeof CreateVehicleRequestConnectorTypesEnum];

/**
 * @export
 */
export const CreateVehicleRequestStatusEnum = {
    Inactive: "Inactive",
    Active: "Active",
    Archived: "Archived",
} as const;
export type CreateVehicleRequestStatusEnum =
    (typeof CreateVehicleRequestStatusEnum)[keyof typeof CreateVehicleRequestStatusEnum];

/**
 * Check if a given object implements the CreateVehicleRequest interface.
 */
export function instanceOfCreateVehicleRequest(
    value: object,
): value is CreateVehicleRequest {
    return true;
}

export function CreateVehicleRequestFromJSON(json: any): CreateVehicleRequest {
    return CreateVehicleRequestFromJSONTyped(json, false);
}

export function CreateVehicleRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): CreateVehicleRequest {
    if (json == null) {
        return json;
    }
    return {
        registrationPlate:
            json["registrationPlate"] == null
                ? undefined
                : json["registrationPlate"],
        jurisdiction:
            json["jurisdiction"] == null ? undefined : json["jurisdiction"],
        organisationId:
            json["organisationId"] == null ? undefined : json["organisationId"],
        friendlyName:
            json["friendlyName"] == null ? undefined : json["friendlyName"],
        make: json["make"] == null ? undefined : json["make"],
        model: json["model"] == null ? undefined : json["model"],
        year: json["year"] == null ? undefined : json["year"],
        colour: json["colour"] == null ? undefined : json["colour"],
        vehicleType:
            json["vehicleType"] == null ? undefined : json["vehicleType"],
        vin: json["vin"] == null ? undefined : json["vin"],
        batteryCapacityKwh:
            json["batteryCapacityKwh"] == null
                ? undefined
                : json["batteryCapacityKwh"],
        macAddress: json["macAddress"] == null ? undefined : json["macAddress"],
        connectorTypes:
            json["connectorTypes"] == null ? undefined : json["connectorTypes"],
        notes: json["notes"] == null ? undefined : json["notes"],
        status: json["status"] == null ? undefined : json["status"],
    };
}

export function CreateVehicleRequestToJSON(
    value?: CreateVehicleRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        registrationPlate: value["registrationPlate"],
        jurisdiction: value["jurisdiction"],
        organisationId: value["organisationId"],
        friendlyName: value["friendlyName"],
        make: value["make"],
        model: value["model"],
        year: value["year"],
        colour: value["colour"],
        vehicleType: value["vehicleType"],
        vin: value["vin"],
        batteryCapacityKwh: value["batteryCapacityKwh"],
        macAddress: value["macAddress"],
        connectorTypes: value["connectorTypes"],
        notes: value["notes"],
        status: value["status"],
    };
}
